var _circle, _path, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShutterButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 37.5,
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 10C56.5685 10 70 23.4315 70 40C70 56.5685 56.5685 70 40 70C23.4315 70 10 56.5685 10 40C10 23.4315 23.4315 10 40 10ZM37.5117 30.0273C37.0624 30.0273 36.6213 30.148 36.2354 30.3779C35.8495 30.6078 35.5332 30.9381 35.3193 31.333L34.709 32.46C34.4952 32.855 34.1788 33.1851 33.793 33.415C33.407 33.645 32.9658 33.7666 32.5166 33.7666H30.0264C29.3653 33.7667 28.7311 34.0296 28.2637 34.4971C27.7962 34.9646 27.5333 35.5987 27.5332 36.2598V47.4795C27.5332 48.1408 27.7961 48.7756 28.2637 49.2432C28.7311 49.7106 29.3653 49.9735 30.0264 49.9736H49.9727C50.6339 49.9736 51.2688 49.7107 51.7363 49.2432C52.2039 48.7756 52.4668 48.1408 52.4668 47.4795V36.2598C52.4667 35.5987 52.2038 34.9646 51.7363 34.4971C51.2687 34.0295 50.6339 33.7666 49.9727 33.7666H47.4834C47.0337 33.7666 46.5922 33.6454 46.2061 33.415C45.8198 33.1846 45.5027 32.8538 45.2891 32.458L44.6836 31.3359C44.4699 30.9401 44.1529 30.6093 43.7666 30.3789C43.3804 30.1486 42.9389 30.0273 42.4893 30.0273H37.5117Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.9999,
    cy: 41.9997,
    r: 4.36325,
    stroke: "white",
    strokeWidth: 1.24664
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShutterButton);
export default __webpack_public_path__ + "static/media/shutter-button.b413f1f0118fa7a906802ec9a5ea08ec.svg";
export { ForwardRef as ReactComponent };